import IQueriesConfigState from "interfaces/queriesConfigState";

const base = "QUERIES_CONFIG";
export const SET_SELECTED_FACILITY_IDS = `${base}_SET_SELECTED_FACILITY_IDS`;
export const SET_INFINITE_SCROLL_MODE = `${base}_SET_INFINITE_SCROLL_MODE`;

export interface ISetFacilities extends Partial<IQueriesConfigState> {
  type: string;
}

export const setSelectedFacilityIds = (
  selectedFacilityIds: string[]
): ISetFacilities => {
  return {
    type: SET_SELECTED_FACILITY_IDS,
    selectedFacilityIds
  };
};

export const setInfiniteScrollMode = (
  isInfiniteScrollOn: boolean
): ISetFacilities => {
  return {
    type: SET_INFINITE_SCROLL_MODE,
    isInfiniteScrollOn
  };
};
